export default "__VITE_ASSET__DDzwAgJv__"